import moment from 'moment';

export function convertSecondsToClockFormat(elapsedTime) {
    let seconds = '0' + (elapsedTime % 60);
    seconds = seconds.slice(-2);

    const minutes = Math.floor(elapsedTime / 60);

    return {
        minutes,
        seconds,
    };
}

export function convertSecondsToHoursMinutes(time){
  const stoh = (time / 60)/60
  console.log((((stoh%1)/100)*60))
  const hours = Math.trunc(stoh)
  const minutes = (stoh % 1)*60
  console.log (`${hours}:${minutes}`);
  return `${hours}:${minutes}`
}



// WEBPACK FOOTER //
// ./src/utilities/time.js